import store from '@/store'

function isMobile() {
  return window.matchMedia('(max-width: 767px)').matches
}

function isTelegram() {
  return !store.getters['telegram/getTgBtn']
}

function getPlatform() {
  if (isMobile()) {
    if (isTelegram()) {
      // telegram
      return 'app-h5'
    } else {
      // mobile browser
      return 'h5'
    }
  } else {
    // web browser
    return 'web'
  }
}

export { isTelegram, getPlatform }
